import React, { Component } from 'react';
import { render } from 'react-dom';
import {
  Circle,
  CircleMarker,
  Map,
  Polygon,
  Polyline,
  Popup,
  Rectangle,
  TileLayer
} from 'react-leaflet-universal';

let L;

export default class Mapa extends Component {
  constructor() {
    super();
    this.state = { showMap: false };
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.taked) {
      return false;
    } else {
      return true;
    }
  }

  componentDidMount() {
    L = require('leaflet');
    require('leaflet-draw');
    this.setState({ showMap: true });
  }

  componentDidUpdate() {
    document.getElementById('weathermap').innerHTML = "<div id='map' className='map'></div>";
    var center = [37, -109.05];

    // Create the map
    var map = L.map('map').setView(center, 7);

    // Set up the OSM layer
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: 'Data © <a href="http://osm.org/copyright">OpenStreetMap</a>',
      maxZoom: 18
    }).addTo(map);

    //Initialise the FeatureGroup to store editable layers
    var editableLayers = new L.FeatureGroup();
    map.addLayer(editableLayers);

    let arr = [];
    let polygon;
    this.props.datos.forEach((item, i) => {
      arr = [];
      item.coordinates.forEach(coordinates => {
        arr.push([coordinates.latitude, coordinates.longitude]);
      });
      let listado = '';
      let color = '';
      item.features.forEach(val => {
        if (val.state) {
          switch (val.name) {
            case 'base':
              color = 'base';
              break;
            case 'client':
              color = 'client';
              break;
            case 'principal':
              color = 'principal';
              break;
            case 'onDuty':
              color = 'onDuty';
              break;
            case 'trip':
              color = 'onTrip';
              break;
            case 'waitingtime':
              color = 'onProductive';
              break;
            case 'workingplace':
              color = 'onWithoutRest';
              break;
            case 'stopped':
              color = 'stopped';
              break;
          }
          listado += `<li class="${color}">${this.props.language.account.geozone[val.name]}</li>`;
        }
      });

      let polygon = L.polygon(arr, { color: 'red', label: i })
        .bindTooltip(
          `<div class="tooltipgeozone">
               <p>
                 ${this.props.language.account.geozone.geozoneName}:${item.alias}
               </p>
               <p>${this.props.language.account.geozone.code}:${item.code}</p>
               <p class="top">${this.props.language.account.geozone.modalEdit.featureTextOne}</p>
               <ul>${listado}</ul>
          </div>`
        )
        .addTo(map);

      let poli = this.props.handleClickPoligon;
      let onPolyClick = function(event) {
        //callFancyboxIframe('flrs.html')
        let label = event.target.options.label;
        poli(label);
      };
      polygon.on('click', onPolyClick);

      if (this.props.select == false) {
        if (i == 0) {
          editableLayers.addLayer(polygon);
          map.fitBounds(polygon.getBounds());
          polygon.setStyle({ color: '#5398c7' });
        }
      } else if (i == this.props.select) {
        editableLayers.addLayer(polygon);
        map.fitBounds(polygon.getBounds());
        polygon.setStyle({ color: '#5398c7' });
      }
    });

    var drawPluginOptions = {
      position: 'topright',
      draw: {
        polygon: {
          allowIntersection: false, // Restricts shapes to simple polygons
          drawError: {
            color: '#e1e100', // Color the shape will turn when intersects
            message: `<strong>${this.props.language.account.geozone.mapMessageOne}</strong>
            ${this.props.language.account.geozone.mapMessageTwo}` // Message that will show when intersect
          },
          shapeOptions: {
            color: '#97009c'
          }
        },
        // disable toolbar item by setting it to false
        polyline: false,
        circle: false, // Turns off this drawing tool
        rectangle: false,
        marker: false,
        circlemarker: false
      },
      edit: {
        featureGroup: editableLayers, //REQUIRED!!
        remove: false
      }
    };

    // Initialise the draw control and pass it the FeatureGroup of editable layers
    if (this.props.buttonShow) {
      var drawControl = new L.Control.Draw(drawPluginOptions);
      map.addControl(drawControl);

      var editableLayers = new L.FeatureGroup();
      map.addLayer(editableLayers);
    }
    let modal = this.props.handleModalPoligon;
    map.on('draw:created', function(e) {
      var type = e.layerType,
        layer = e.layer;
      editableLayers.addLayer(layer);
      modal(e);
    });

    let editPolygon = this.props.handleEditPoligon;
    map.on('draw:edited', function(e) {
      var layers = e.layers;
      layers.eachLayer(function(layer) {
        editPolygon({ label: layer.options.label, ll: layer._latlngs });
      });
    });
  }

  render() {
    if (this.state.showMap) {
      return <div id="weathermap" />;
    } else {
      return <div id="weathermap" />;
    }
  }
}



// WEBPACK FOOTER //
// ./source/client/components/account_geozone/mapa.jsx